import React, { useEffect, useMemo } from 'react';
import { Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { actionFetchFeatureTagOptions } from 'reducers/seniorSearch';
import { selectFeatureTagOptionsInfo } from 'utils/selectors/selectors';
import { CsSelect } from 'components/antd-extension/CsSelect';

const FeatureTagSelect = ({
  appId,
  isShowAsText,
  isReadOnly,
  isMultiSelect,
  value,
  onChange,
  selectProps,
}) => {
  const { hasFetched, options } = useSelector(selectFeatureTagOptionsInfo);
  const dispatch = useDispatch();

  const valueToLabel = useMemo(() => {
    return Object.fromEntries((options || []).map((item) => [item.value, item.label]));
  }, [options]);

  useEffect(() => {
    if (!appId) {
      return;
    }
    if (!hasFetched) {
      dispatch(actionFetchFeatureTagOptions());
    }
  }, [appId]);

  if (isShowAsText) {
    let text;
    if (isMultiSelect) {
      text = (value || []).map((x) => valueToLabel[x] || x).join(',');
    } else {
      text = valueToLabel[value] || value;
    }
    return <span>{ text }</span>;
  }

  return <CsSelect
    style={{ width: '100%', fontSize: '14px' }}
    mode={isMultiSelect ? 'multiple' : undefined}
    options={options}
    value={value}
    onChange={(v) => {
      if (isReadOnly) {
        return;
      }
      onChange?.(v);
    }}
    {...selectProps}
  />
}

export default FeatureTagSelect;
